import type { ReactNode } from 'react';
import { WEB_ICO } from './icons';

interface WebTopBarProps {
  title: ReactNode;
  sub?: ReactNode;
  onBack?: (() => void) | null;
  right?: ReactNode;
  /** Điện thoại: thấp hơn, lề hẹp, bỏ dòng mô tả để tiêu đề không bị bóp. */
  compact?: boolean;
}

export function WebTopBar({ title, sub, onBack, right, compact = false }: WebTopBarProps) {
  return (
    <header
      style={{
        height: compact ? 56 : 68,
        flexShrink: 0,
        borderBottom: '1px solid var(--border-default)',
        background: 'var(--surface-page)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: compact ? '0 16px' : '0 28px',
        fontFamily: 'var(--font-vi)',
      }}
    >
      {onBack && (
        <button
          onClick={onBack}
          aria-label="Quay lại"
          style={{
            width: 36,
            height: 36,
            marginLeft: -8,
            borderRadius: 8,
            border: '1px solid var(--border-default)',
            background: 'var(--surface-page)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {WEB_ICO.back()}
        </button>
      )}
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 16.5, fontWeight: 700, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {title}
        </div>
        {sub && !compact && <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 1 }}>{sub}</div>}
      </div>
      <div style={{ flex: 1 }} />
      {right}
    </header>
  );
}
